import styleMessageBar from './message-bar.shadow.less';

class MessageBar extends HTMLElement {
    constructor(){
        super();

        this.root = this.attachShadow({ mode: 'open' });
        this.applyStyle(styleMessageBar);

        // 初始化 shadow DOM 結構 (不含內容)
        this.init();

        // this._handleResize = this._handleResize.bind(this);
    }

    // === 注入樣式 === //
    applyStyle(style){
        const elem = document.createElement('style');
        elem.textContent = style;
        this.root.appendChild(elem);
    }

    // === 初始化，在 constructor 中執行 === //
    init(){
        // 初始化 shadow DOM 結構 (不含內容)
        // const wrapper = document.createElement('div');
        // wrapper.className = 'wrapper';
        // this.root.appendChild(wrapper);
    }

    // *** 以下四種內建的生命週期方法，都是 Callback 結尾 *** //

    // === 內建生命週期: 當元件被插入到 DOM 中時調用 === //
    // 與畫面實際出現、互動相關的行為，都應該放在 connectedCallback
    // 包括 UI 行為、事件綁定、資料載入、動畫等
    connectedCallback(){
        // addEventListener
        window.addEventListener('resize', this._handleResize);
    }

    // === 內建生命週期: 當元件被移出 DOM 時調用 === //
    // 移除方法，在父層用 .remove() 從 DOM 中移除 <message-bar>
    // 如果有不是綁在 component 本身的東西
    // 在卸載時務必手動移除，以免造成 memory leak，例如以下幾種
    // 1. 綁定在 window, document, body 上的事件監聽器
    // 2. setInterval, setTimeout, WebSocket, MutationObserver 等
    disconnectedCallback(){
        // 綁定在 shadoe DOM 的事件監聽器會被自動移除，不用手動移除
        // 除此之外都需要手動移除
        // window.removeEventListener('resize', this._handleResize);
    }

    // === 內建生命週期: 當元件的屬性 (attributes) 變動時調用 === //
    // changed, added, removed, or replaced
    // 只有用 static get observedAttributes 列出的屬性才會被追蹤
    attributeChangedCallback(name, oldValue, newValue){
        // if(name === 'position'){
            // 例如更新文字內容
            // console.log(newValue); // -> Alice
        // }
    }

    // 注意：如果要啟用 attributeChangedCallback()，需要搭配 getter
    // 用 static get 定義 observedAttributes
    // (瀏覽器會自動讀取 component.observedAttributes 值，來決定要監聽哪些屬性變化)
    // 所以需要指定哪些屬性需要監聽，當這些屬性改變時會觸發 attributeChangedCallback
    static get observedAttributes() {
        // ex: <message-bar title="Alice" active="running"><message-bar />
        // return ['position'];
    }

    // === 內建生命週期: 元件被移到另一個 document 時（如 iframe 之間) === //
    // 很少用，一般可略過
    adoptedCallback(){

    }

    // *** 以下為自訂方法 *** //

    // seeter 從外部接收資料
    // 當資料改變時可做相應的處理，例如更新內容等
    /** @param {(Object|Array)} [data=null] - 傳入資料 */
    set setData(data = null){
        this.render(data);
    }

    // === 根據資料產生內容 === //
    render(data){
        if(!data){
            return;
        }

        const wrapper = document.createElement('div');
        wrapper.className = 'wrapper';

        wrapper.innerHTML = data;

        this.root.appendChild(wrapper);
    }

    // === 向外傳遞資料 === //
    // 利用 dispatchEvent 觸發自訂的事件，向上傳遞資料給父層
    dispatchCustomEvent(name, detail = {}) {
        this.dispatchEvent(new CustomEvent(name, {
            detail: detail,
            bubbles: true,
            composed: true
        }));
    }

    // === window.resize === //
    _handleResize(){
        // 需要注意，以這個綁定在 window 上的事件處理器為例
        // 如果在 constructor 中不手動綁定 this
        // this._handleResize = this._handleResize.bind(this);
        // 那麼這邊預設指向的 this 會變成 window（或 undefined，如果是 strict mode）
    }

}

// 單純在外部註冊為 Web Component 使用時
// 因為是匯入整個 js 檔，所以這一行會執行
customElements.define('message-bar', MessageBar);

// 從外部文件中匯入 web component 的使用範例
/*
import '../../web-components/message-bar/message-bar';

const component = document.createElement('message-bar');
document.body.appendChild(component);

component.setData = {
    title: 'Alice',
    active: '休眠'
};

component.setAttribute('active', '跑步');
*/
